import ControlElement from '@r1-frontend/ui-react/components/typography/controlElement';
import { Paragraph5 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { NBSP } from '@r1-frontend/ui-react/tokens/symbols';


export const getBannerData = (): { title: string, description: JSX.Element, image: { url: string, urlWebp: string } }  => {
    return {
        title: `Рассрочка от${NBSP}банка-партнёра`,
        description: <Paragraph5>
           Пользуйтесь сразу, а&nbsp;платите постепенно. <ControlElement type={'small'}>Подробнее</ControlElement>
        </Paragraph5>,
        image: {
            url: require('~/static/images/equipment/credit/banner.png'),
            urlWebp: require('~/static/images/equipment/credit/banner.webp'),
        },
    };
};
